import styled from "@emotion/styled";

export const lightTheme = {
    backgroundColor: "#FFFFFF",
    textColor: "black",
    textColor2: "#333",
    titleColor: "#999"
};

export const darkTheme = {
    backgroundColor: "#212426",
    textColor: "#ccc",
    textColor2: "#BDBDBD",
    titleColor: "#666"
};

export const theme = {
    light: lightTheme,
    dark: darkTheme,
};